import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { primaryColor } from "../hooks/useFirstTimeRegister";
import { REGISTER_USER_TYPE_RADIO_OPTIONS } from "./register/registerFieldConfig";

export default function RegisterUserTypeSelection({ userType, onUserTypeRadioChange }) {
  return (
    <Box>
      <FormControl component="fieldset" fullWidth>
        <FormLabel
          component="legend"
          sx={{
            fontWeight: 600,
            color: primaryColor,
            mb: 1.5,
            fontSize: "1rem",
          }}
        >
          Who is registering today?
        </FormLabel>
        <RadioGroup value={userType} onChange={onUserTypeRadioChange} sx={{ gap: 1 }}>
          {REGISTER_USER_TYPE_RADIO_OPTIONS.map((opt) => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              data-testid={`register-user-type-${opt.value}`}
              control={<Radio size="small" sx={{ color: primaryColor, p: 0.75 }} />}
              label={
                <Box sx={{ py: 0.25 }}>
                  <Typography variant="body1" fontWeight={600} sx={{ lineHeight: 1.4 }}>
                    {opt.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.3 }}>
                    {opt.subtitle}
                  </Typography>
                </Box>
              }
              sx={{
                border: "2px solid #E0E0E0",
                borderRadius: "0px",
                px: 1.5,
                py: 1,
                m: 0,
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "rgba(51, 51, 51, 0.04)",
                  borderColor: primaryColor,
                },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
}

RegisterUserTypeSelection.propTypes = {
  userType: PropTypes.string,
  onUserTypeRadioChange: PropTypes.func.isRequired,
};
